import { noop } from 'ui-components/default-props/noop';

import { DropdownField } from 'ui-components/components/dropdown/dropdown-field';

/**
 * @deprecated Use `Select` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 * A simple dropdown component.
 * @param {object} props - The component props.
 * @param {(option: DropdownOption) => boolean} [props.getOptionIsDisabled] - Defaults to `option.disabled`
 * @param {(option: DropdownOption) => string} [props.getOptionLabel] - Defaults to `option.label`
 * @param {(option: DropdownOption) => string} [props.getOptionValue] - Defaults to `option.value`
 * @param {Array} props.options - The dropdown options.
 * @param {string} props.placeholder - The placeholder text for the dropdown.
 * @param {string} props.label - The label for the dropdown.
 * @param {string} props.selectedItemValue - The value of the selected item.
 * @param {(optionValue: string, previousOptionValue?: string) => void} props.onItemSelected - Callback function when an item is selected.
 * @param {string} [props.className] - Additional class names to apply to the dropdown.
 * @param {ReactNode} [props.inlineMessage]
 * @param {string} [props.inlineMessageType]
 * @param {boolean} [props.isClearable]
 * @returns {JSX.Element} The rendered dropdown component.
 */
export const SimpleDropdown = ({
  getOptionIsDisabled,
  getOptionLabel,
  getOptionValue,
  options = [],
  placeholder = '',
  label = '',
  selectedItemValue = '',
  onItemSelected = noop,
  className = '',
  inlineMessage,
  inlineMessageType,
  isClearable = false,
}) => {
  return (
    <DropdownField
      className={className}
      getOptionIsDisabled={getOptionIsDisabled}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      inlineMessage={inlineMessage}
      inlineMessageType={inlineMessageType}
      isClearable={isClearable}
      label={label}
      onItemSelected={onItemSelected}
      options={options}
      placeholder={placeholder}
      selectedItemValue={selectedItemValue}
    />
  );
};
